import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { redirectAfterAuth, hasPendingReviewReturn } from "@/lib/authRedirect";
import GoogleSignInButton from "@/components/site/GoogleSignInButton";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(email, password, name);
      toast.success("Selamat datang di SekolahKita");
      // Post-auth routing priority: a pending review submission takes
      // precedence over new-user onboarding — the wizard will auto-submit
      // then land the user on /review-success. Onboarding surfaces on the
      // next normal entry (still unmarked as complete).
      if (hasPendingReviewReturn()) {
        redirectAfterAuth(nav);
      } else {
        nav("/onboarding", { replace: true });
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Gagal mendaftar");
    } finally { setBusy(false); }
  };

  return (
    <div data-testid="register-page" className="max-w-md mx-auto px-6 py-16">
      <div className="text-xs uppercase tracking-widest text-[#4B5563]">Gabung dan mulai diskusi sekarang</div>
      <h1 className="font-serif-display text-4xl text-[#1F2937] mt-2">Buat akun Anda</h1>
      <form onSubmit={submit} className="mt-8 space-y-3">
        <Input placeholder="Nama Anda" value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name" className="h-11 rounded-xl border-[#EAE7E0] bg-white" />
        <Input type="email" placeholder="Masukan email Anda" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email" className="h-11 rounded-xl border-[#EAE7E0] bg-white" />
        <Input type="password" placeholder="Buat Password (min. 6 karakter)" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password" className="h-11 rounded-xl border-[#EAE7E0] bg-white" />
        <Button type="submit" disabled={busy} data-testid="register-submit" className="w-full h-11 rounded-full bg-[#E07A5F] hover:bg-[#C96D55] text-white">{busy ? "Membuat…" : "Buat akun"}</Button>
      </form>

      <div className="my-6 flex items-center gap-3 text-xs uppercase tracking-widest text-[#4B5563]">
        <div className="h-px flex-1 bg-[#EAE7E0]" /> atau <div className="h-px flex-1 bg-[#EAE7E0]" />
      </div>
      <GoogleSignInButton text="signup_with" fallbackTo="/profile" testid="register-google" />

      <div className="mt-6 text-sm text-[#4B5563]">
        Sudah punya akun?{" "}
        <Link to="/login" className="text-[#1E3A8A] hover:text-[#E07A5F]" data-testid="link-login">Masuk</Link>
      </div>
    </div>
  );
}
